import TemplateContents from './TemplateContents';

export default class extends TemplateContents {
  constructor(param) {
    super(param);
  }

  init() {
    super.init();
  }

  reset() {
    super.reset();
    this.setVars();
  }

  destruct() {
    super.destruct();
  }

  setVars() {
    super.setVars();
  }

  setDom() {
    super.setDom();

    this.toTopDom = document.querySelector('footer .to_top');
  }

  initEvents() {
    super.initEvents();

    this.toTopDom.addEventListener('click', (event) => {
      this.pack.anchorScroll(0);
    });
  }

  start() {}

  scrollHandler() {}

  enterframe() {}

  enterframeThinOut() {}

  executeResize() {
    super.executeResize();
  }
}
